import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/pro-solid-svg-icons/faLongArrowAltRight';
export var Arrow = function (_a) {
    var disabled = _a.disabled;
    return (React.createElement("li", { className: "mt-2" },
        React.createElement("p", { className: "text-2xl " + (disabled ? 'text-contentAreaBorder' : 'text-secondary') },
            React.createElement(FontAwesomeIcon, { icon: faLongArrowAltRight }))));
};
